export default {
    'SETTINGS.EMAIL.BUILDER.PAGE_TITLE': 'Emails',
    'SETTINGS.EMAIL.BUILDER.FILTER.ALL': 'Tous',
    'SETTINGS.EMAIL.BUILDER.FILTER.CONFIRMATION': 'Confirmation',
    'SETTINGS.EMAIL.BUILDER.FILTER.UPDATE': 'Modification',
    'SETTINGS.EMAIL.BUILDER.FILTER.CANCELLATION': 'Annulation',
    'SETTINGS.EMAIL.BUILDER.FILTER.REMINDER': 'Rappel',
    'SETTINGS.EMAIL.BUILDER.COLUMN.SUB_ACCOUNT': 'Sous-compte',
    'SETTINGS.EMAIL.BUILDER.COLUMN.METHOD': 'Mode de RDV',
    'SETTINGS.EMAIL.BUILDER.COLUMN.EMAIL_TYPE': 'Type d\'email',
    'SETTINGS.EMAIL.BUILDER.COLUMN.STATUS': 'Statut',
    'SETTINGS.EMAIL.BUILDER.COLUMN.LAST_UPDATE': 'Dernière mise à jour',
    'SETTINGS.EMAIL.BUILDER.STATUS.DEFAULT': 'Par défaut',
    'SETTINGS.EMAIL.BUILDER.STATUS.CUSTOMISED': 'Personnalisé',
    'SETTINGS.EMAIL.BUILDER.PERMISSION_LABEL': 'Configuration des emails',
    'SETTINGS.EMAIL.BUILDER.BACK_TO_EMAILS': 'Retour aux emails',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.TITLE': 'Configuration',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.SUB_ACCOUNT': 'Sous-compte',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.METHOD': 'Mode de RDV',
    'SETTINGS.EMAIL.BUILDER.CONFIGURATION.EMAIL_TYPE': 'Type d\'email',
    'SETTINGS.EMAIL.BUILDER.SUBJECT.TITLE': 'Objet',
    'SETTINGS.EMAIL.BUILDER.HEADER.TITLE': 'En-tête',
    'SETTINGS.EMAIL.BUILDER.HEADER.DESCRIPTION': 'Salutation et introduction de votre email',
    'SETTINGS.EMAIL.BUILDER.BODY.TITLE': 'Corps du message',
    'SETTINGS.EMAIL.BUILDER.BODY.DESCRIPTION': 'Détails du rendez-vous. Saisissez librement et ajoutez des variables avec le bouton « Insérer une variable ».',
    'SETTINGS.EMAIL.BUILDER.INSERT_VARIABLE': 'Insérer une variable',
    'SETTINGS.EMAIL.BUILDER.INSERT_LINK': 'Insérer un lien',
    'SETTINGS.EMAIL.BUILDER.LINK.TEXT_TO_DISPLAY': 'Texte à afficher',
    'SETTINGS.EMAIL.BUILDER.LINK.ERRORS.INVALID_DOMAIN': 'Veuillez saisir un domaine valide',
    'SETTINGS.EMAIL.BUILDER.LINK.ACTIONS.INSERT': 'Insérer',
    // eslint-disable-next-line max-len
    'SETTINGS.EMAIL.BUILDER.CONDITIONAL_VARIABLES_WARNING': 'Les variables en orange sont conditionnelles, disponibles uniquement pour certains modes de RDV (ex. appointment_address uniquement pour En agence).',
    'SETTINGS.EMAIL.BUILDER.APPOINTMENT_TYPE_DESCRIPTION.TITLE': 'Description du type de RDV',
    'SETTINGS.EMAIL.BUILDER.APPOINTMENT_TYPE_DESCRIPTION.HINT': 'Activez pour inclure la description du type de RDV dans l\'email',
    'SETTINGS.EMAIL.BUILDER.ADDITIONAL_TEXT.TITLE': 'Texte additionnel',
    'SETTINGS.EMAIL.BUILDER.ADDITIONAL_TEXT.DESCRIPTION': 'Texte libre pour toute information supplémentaire à partager avec vos clients',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.TITLE': 'Boutons d\'action',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.DESCRIPTION': 'Pour les RDV pris via Selfcare, incluez les liens d\'annulation ou de modification.',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.CANCEL': 'Annuler mon rendez-vous',
    'SETTINGS.EMAIL.BUILDER.ACTION_BUTTONS.MODIFY': 'Modifier mon rendez-vous',
    'SETTINGS.EMAIL.BUILDER.FOOTER.TITLE': 'Pied de page',
    'SETTINGS.EMAIL.BUILDER.FOOTER.DESCRIPTION': 'Phrase de clôture de votre email',
    'SETTINGS.EMAIL.BUILDER.PREVIEW.TITLE': 'Aperçu',
    'SETTINGS.EMAIL.BUILDER.PREVIEW.SUBTITLE': 'Variables remplacées par des valeurs d\'exemple',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.SAVE': 'Enregistrer',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.SEND_TEST': 'Envoyer un test',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET': 'Réinitialiser par défaut',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET_CONFIRM': 'Réinitialiser',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.RESET_CANCEL': 'Annuler',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.STAY_ON_PAGE': 'Rester sur la page',
    'SETTINGS.EMAIL.BUILDER.ACTIONS.LEAVE_WITHOUT_SAVING': 'Quitter sans enregistrer',
    'SETTINGS.EMAIL.BUILDER.ERRORS.REQUIRED_FIELD': 'Ce champ est obligatoire',
    'SETTINGS.EMAIL.BUILDER.ERRORS.MAX_LENGTH': 'Maximum {n} caractères',
    'SETTINGS.EMAIL.BUILDER.ALERTS.UNSAVED_CHANGES_TITLE': 'Modifications non enregistrées',
    'SETTINGS.EMAIL.BUILDER.ALERTS.UNSAVED_CHANGES': 'Des modifications non enregistrées seront perdues. Voulez-vous quitter ?',
    'SETTINGS.EMAIL.BUILDER.ALERTS.RESET_TITLE': 'Réinitialiser cet e-mail avec son contenu par défaut ?',
    // eslint-disable-next-line max-len
    'SETTINGS.EMAIL.BUILDER.ALERTS.RESET_DESCRIPTION': 'Vos personnalisations (en-tête, corps, pied de page, textes additionnels, boutons) seront perdues si vous confirmez la réinitialisation.',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SAVE_SUCCESS': 'Modifications enregistrées',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SEND_TEST_SUCCESS': 'Email de test envoyé',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SEND_TEST_SUCCESS_COUNT': 'Test envoyé à {n} adresse | Test envoyé à {n} adresses',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.SAVE_BEFORE_SEND_TEST': 'Veuillez enregistrer vos modifications avant d\'envoyer un test',
    'SETTINGS.EMAIL.BUILDER.NOTIFICATIONS.RESET_SUCCESS': 'Modèle réinitialisé avec son contenu par défaut',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.TITLE': 'Envoyer un e-mail de test',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.RECIPIENTS': 'Destinataires',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.PLACEHOLDER': 'Ajouter un e-mail...',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.HINT_EMPTY': 'Ajoutez jusqu\'à 5 destinataires',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.RECIPIENTS_LEFT': '{n} destinataire restant | {n} destinataires restants',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.INVALID_EMAIL': 'Adresse e-mail invalide',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.CANCEL': 'Annuler',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.SEND': 'Envoyer le test',
    'SETTINGS.EMAIL.BUILDER.SEND_TEST.SENDING': 'Envoi en cours...',
};
